<!-- Department header -->
<app-dept-header *ngIf="deptId != undefined"></app-dept-header>
<!-- Department header -->
<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <header><h1>Frequently Asked Questions</h1></header>
    <div class="row">

      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section id="course-detail">
            <article class="course-detail">

              <section id="course-faq">
<!--                <header><h2>FAQ</h2></header>-->
                <div *ngIf="allFaq.length == 0">
                  <h3>No FAQ's...</h3>
                </div>

                <div class="faq-accordions">
                  <div class="panel-group" id="accordion">
                    <div class="panel panel-default" *ngFor="let faqItem of allFaq let i=index">
                      <div class="panel-heading">
                        <h4 class="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#question-{{i}}">
                            <span class="question">{{faqItem.faq.question}}</span>
                          </a>
                        </h4>
                      </div>
                      <div id="question-{{i}}" class="panel-collapse collapse in">
                        <div class="panel-body">
                          {{faqItem.faq.answer}}
                        </div>
                      </div>
                    </div>

                  </div>
                </div><!-- /.faq-accordion -->
              </section><!-- /#course-faq -->


            </article><!-- /.course-detail -->
          </section><!-- /.course-detail -->
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <aside class="news-small" id="news-small">
            <header>
              <h2>Latest News</h2>
            </header>
            <div class="section-content">

              <article *ngFor="let newsItem of allNewsData">
                <figure class="date"><i class="fa fa-calendar"></i>{{ newsItem.commence_date | date:'MMMM d, y' }}</figure>
                <header>
                  <a routerLink="/info/{{newsItem.id}}">
                    {{newsItem.title.slice(0,50)}}...
                  </a>
                </header>
              </article><!-- /article -->

            </div><!-- /.section-content -->
<!--            <a href="" class="read-more">All News</a>-->
          </aside><!-- /.news-small -->
        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
      <!-- end SIDEBAR Content-->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
